import { IconButton, Menu, MenuItem } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { userSelector } from "../../../modules/App/state/selectors";
import styles from "./styles.module.scss";

const User = ({ onExit }) => {
    const user = useSelector(userSelector);
    const [ anchorEl, setAnchorEl ] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={styles.user}>
            {
                user && (
                    <div className={styles.userInfo}>
                        {`${user.first_name} ${user.last_name}`}
                    </div>
                )
            }

            <IconButton
                onClick={handleClick}
            >
                <PersonIcon/>
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={onExit}>Logout</MenuItem>
            </Menu>
        </div>
    );
};

export default User;
